<button mat-button [matMenuTriggerFor]="langMenu" class="language-button">
  <mat-icon>language</mat-icon>
  <span class="lang-code">{{ currentLabel }}</span>
  <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
</button>

<mat-menu #langMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let lang of languages"
    (click)="selectLanguage(lang.code)"
    [class.active-language]="lang.code === currentLanguage"
  >
    {{ lang.label }}
  </button>
</mat-menu>
